/**
 * Renders a modal window
 */

import React from 'react';
import { observer } from 'mobx-react';

// Components
import * as icons from '../ui/Icons';

const Modal = observer(class Modal extends React.Component {
  render() {
    const { AppStore } = this.props.store;
    const { modalContent, modalLeave } = AppStore;

    let Component = null;
    const componentProps = {};

    if (modalContent.component) {
      Component = modalContent.component
    };

    if (modalContent.props) {
      Object.keys(modalContent.props).forEach(prop => {
        componentProps[prop] = modalContent.props[prop];
      });
    }

    return (
      <div className="modal">
        <article
          className={`modal__content${
            modalContent.type === 'image' ? ' modal__content--image' : ''
          }${
            modalLeave ? ' modal__content--exiting' : ''
          }`}
        >  
          <header className="modal__head">
            {AppStore.modalHeading &&
              <h2 className="modal__title">
                {AppStore.modalHeading}
              </h2>
            }

            <button
              className="modal__close"
              type="button"
              onClick={AppStore.dismissModal}
            >
              <icons.times />
              <span className="meta">Close</span>
            </button>
          </header>

          {modalContent.type === 'image' &&
            <figure className="modal__img">
              <img
                src={modalContent.img}
                alt={modalContent.alt}
              />
            </figure>
          }

          {Component &&
            <Component
              {...this.props} 
              {...componentProps}
            />
          }
        </article>
      </div>
    )
  }
})

export default Modal;
